'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:tower:comment');
}

var _invoke = require('../invoke');

/**
 * 打开native评论输入界面
 *
 * 支持版本
 * + MtLvxing/1.3+
 *
 * @memberof tower
 * @static
 * @name comment
 * @param {Object} opts
 * @return {Promise<object | err>}
 * @example
 *  hbnb.tower.comment({
 *          type: 'simple',
 *          placeholder: '请在此输入',
 *          content: '评论内容',
 *          limit: 350,
 *          buttonText: '发送',
 *      })
 *      .then(function(result) {
 *          result = {
 *              status: 0,
 *              content: '用户输入的内容',
 *          }
 *      })
 *      .catch(function(err) {
 *          err = {
 *              message: "fail",
 *              status: -1
 *          }
 *      });
 */

module.exports = function(data) {
    var p = new Promise(function(resolve, reject) {
        _invoke('tower', 'comment', {
            type: data.type || 'simple',
            placeholder: data.placeholder || '',
            content: data.content || '',
            limit: data.limit || null,
            buttonText: data.buttonText,

            callback: function(result) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('comment result is %j', result);
                }
                resolve(result);
            },
            errback: reject
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/tower/comment.js
// module id = 152
// module chunks = 0 8 9